import { applyMiddleware, createStore, type Store } from 'redux'
import createSagaMiddleware from 'redux-saga'
import rootReducer, { type IState } from '../redux/reducers'
import rootSaga from '../redux/sagas'

export function initStore() {
    const sagaMiddleware = createSagaMiddleware()
    const middlewares = [sagaMiddleware]

    const reduxStore = createStore(rootReducer, applyMiddleware(...middlewares))

    sagaMiddleware.run(rootSaga)

    globalReduxStore = reduxStore

    return reduxStore
}

// Escape hatch for legacy code, try to avoid using
export let globalReduxStore: Store<IState>
